var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { height: "100%" } },
    [
      _c(
        "v-layout",
        { attrs: { column: "", "fill-height": "" } },
        [
          _c(
            "v-flex",
            { staticStyle: { margin: "4px 20px" }, attrs: { shrink: "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-0",
                  attrs: { icon: "", small: "" },
                  on: { click: _vm.returnToToolbar }
                },
                [
                  _c("v-icon", { staticStyle: { "font-size": "10px" } }, [
                    _vm._v("arrow_back_ios")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticStyle: { "text-transform": "uppercase" } }, [
                _vm._v(_vm._s(_vm.title) + "...")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3f66474", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3f66474","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskSideSectionContainer.vue
// module id = null
// module chunks = 